<template>
  <div>
    <div class="box">
      <div>
        <span v-for="item in tabs" :key="item.id" :class="radio == item.id ? 'index active' : 'index'"
          @click="changetab(item)">{{ item.title }}</span>
      </div>
    </div>

    <!-- 这里是使用动态组件 -->
    <component :is="activeComponentName"></component>
  </div>
</template>

<script>
import { goNewSys } from '@/util/index'
import Index from "./dev/index.vue";
import Auditingunusual from "./audit/index.vue";
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      tabs: [{
        title: "APP发版记录",
        id: 32,
        componentName: 'Index'
      }, {
        title: "APP审核异常监控",
        id: 33,
        componentName: 'Auditingunusual'
      }],
      activeComponentName: "Index",
      radio: 32,
      changeCheckList: [],
      checkList: [],
      dialogVisible: false,
      DashboardSetting: [],
    };
  },
  components: {
    Index,
    Auditingunusual
  },
  mounted() {
    // 跳转新的系统
    goNewSys({
      path: "/business/subsidiary_management/app_release_review",
      target: "_self"
    })
    return;
    // 获取通用字典
    this.getDictData()
    if (this.$route.query.componentName && this.$route.query.id) {
      this.radio = this.$route.query.id
      this.activeComponentName = this.$route.query.componentName
    }
  },
  methods: {
    ...mapActions(['getDictData']),
    // tab切换
    changetab(item) {
      if (this.radio == item.id) return
      this.radio = item.id
      this.activeComponentName = item.componentName
    },
  },
};
</script>

<style lang="less" scoped>
.radio_button {
  width: 75px;
}

.box {
  background-color: #fff;
  margin: 20px 0;
  display: flex;
  justify-content: space-between;

  span {
    display: inline-block;
    padding: 15px 0 12px 0;
    font-size: 16px;
    color: rgba(90, 92, 96, 0.65);
    cursor: pointer;
  }

  .index {
    margin: 0 60px 0 18px;
  }

  .advertisement {
    margin-right: 60px;
  }

  .active {
    font-size: 16px;
    font-weight: bold;
    color: #232528;
    border-bottom: 2px solid #ff981f;
  }

  .margin-top {
    margin-top: 5px;
  }
}

.btn {
  word-wrap: break-word;
  width: 50px;
  height: 50px;
  color: #fff;
  background: #409eff;
  border-radius: 50%;
  text-align: center;
}

.pos_ab {
  position: absolute;
  bottom: 15vh;
  right: 5vh;
}
</style>